export const home = "/";
export const resume = "/resume";
export const about = "/about";
export const github = "https://github.com/nickerzb/personal-website";
